import React, { useCallback } from 'react';
import WpButtonDropdown from 'Wpds/components/button/WpButtonDropdown';
import { WpDropdownMenu, WpDropdownMenuItem } from 'Wpds/components/dropdown';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { useFlags } from 'launchdarkly-react-client-sdk';

type Props = {
  onAddTemplate: Function;
  onCreateTemplate: Function;
};

function WorkspaceTemplatesButton({ onAddTemplate, onCreateTemplate }: Props) {
  const handleClickAddTemplate = useCallback(() => {
    onAddTemplate();
  }, [onAddTemplate]);

  const handleClickCreateTemplate = useCallback(() => {
    onCreateTemplate();
  }, [onAddTemplate]);

  const { customWorkspaceTemplates: customWorkspaceTemplatesFlag } = useFlags();

  return (
    <WpButtonDropdown
      variant="tertiary"
      onClick={handleClickAddTemplate}
      addOnDropdownMenu={
        customWorkspaceTemplatesFlag && (
          <WpDropdownMenu>
            <WpDropdownMenuItem onClick={handleClickAddTemplate}>Browse Templates</WpDropdownMenuItem>
            <WpDropdownMenuItem onClick={handleClickCreateTemplate}>Save Workspace as Template</WpDropdownMenuItem>
          </WpDropdownMenu>
        )
      }
    >
      <WpIcon name="copy" /> Templates
    </WpButtonDropdown>
  );
}

export default WorkspaceTemplatesButton;
